/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */

import { gql } from '@apollo/client'

import { RANK_STAT_FRAGMENT } from '../fragments/RankStatFragment'

export const GET_STORE_PEER_COMPARISONS = gql`
  query GetStorePeerComparisons($filters: PeerComparisonFilter!) {
    storePeerComparisons(filters: $filters) {
      ...RankStat
    }
  }
  ${RANK_STAT_FRAGMENT}
`
